module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-43-min.5d839050.jpg";